import { forwardRef } from "react";
import { Calendar } from "lucide-react";


export const DateInput = forwardRef(({ value, onClick, placeholder }, ref) => (
  <button
    type="button"
    onClick={onClick}
    ref={ref}
    className="flex  items-center  gap-2 border rounded-lg px-5 py-1.5 w-full text-left"
  >
    <Calendar className="w-4 h-4 text-gray-500" />
    <span className={value ? "text-black" : "text-gray-400"}>
      {value || placeholder}
    </span>
  </button>
));
